import React from 'react';
import { AlertTriangle, AlertCircle, CheckCircle2 } from 'lucide-react';
import { cn } from '@/lib/utils';

const IssueList = ({ issues, type = 'critical' }) => {
  const getIcon = () => {
    switch(type) {
      case 'critical': return <AlertTriangle className="w-5 h-5 text-destructive" />;
      case 'warning': return <AlertCircle className="w-5 h-5 text-warning" />;
      case 'passed': return <CheckCircle2 className="w-5 h-5 text-verify" />;
      default: return null;
    }
  };

  const getHeaderColor = () => {
    switch(type) {
      case 'critical': return 'text-destructive';
      case 'warning': return 'text-warning';
      case 'passed': return 'text-verify';
      default: return 'text-slate-900';
    }
  };

  const getBorderColor = () => {
    switch(type) {
      case 'critical': return 'border-l-destructive';
      case 'warning': return 'border-l-warning';
      case 'passed': return 'border-l-verify';
      default: return 'border-l-slate-300';
    }
  };

  if (!issues || issues.length === 0) return null;

  return (
    <div className="space-y-3" data-testid={`issue-list-${type}`}>
      <div className="flex items-center gap-2 mb-3">
        {getIcon()}
        <h3 className={cn("font-outfit font-bold text-lg", getHeaderColor())}>
          {type === 'critical' && 'Critical Issues'}
          {type === 'warning' && 'Warnings'}
          {type === 'passed' && 'Passed Checks'}
        </h3>
        <span className="text-sm text-slate-500">({issues.length})</span>
      </div>
      <div className="space-y-3">
        {issues.map((issue) => (
          <div
            key={issue.id}
            className={cn(
              "bg-white border-l-4 border border-slate-200 rounded-md p-4",
              getBorderColor()
            )}
            data-testid={`issue-item-${issue.id}`}
          >
            <h4 className="font-public font-semibold text-slate-900 mb-1">{issue.title}</h4>
            <p className="text-sm text-slate-600">{issue.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IssueList;
